module.exports = __webpack_public_path__ + "img/1-2.b71cdad1.jpg";